import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
// import NumberFormat from 'react-number-format';
import TextAmount from 'components/text/TextAmount';

const InputAmount = ({
  name, value, onChange, onFocus, onBlur, placeholder, allowNegative, disabled, decimalScale}) => {

    const [amount, setAmount] = useState(0);
    const [max, setMax] = useState(9999999999);
    const [min, setMin] = useState(allowNegative ? -9999999999 : 0);
  
    const handleChange = (value) => {
    if (typeof onChange === 'function') {
      value = value.split(".").join("");
      const re = /^-?[0-9]\d*(\.\d+)?$/;
      const number = Number(value);
      if (value.charAt(0) === '0' && value.charAt(1)) {
        value = value.substring(1, value.lenght);
      }
      if (value == "") {
        onChange(null);
        setAmount("");
      }else if(allowNegative && value == "-") {
        onChange(null);
        setAmount(value);
      }else if (re.test(value) && number <= max && number >= min) {
        onChange(number);
     }
    }
  };

  useEffect(() => {
    if (value != null) {
      setAmount(Intl.NumberFormat('de-DE').format(value));
    }
  }, [value]);

  const handleFocus = e => {
    if (typeof onFocus === 'function') {
      onFocus(e.target.value);
    }
  };

  const handleBlur = e => {
    if (typeof onBlur === 'function') {
      onBlur(e.target.value);
    }
  };

  let _id = name + '_' + Math.floor(Math.random() * Math.floor(5000));  

  if (disabled){
    return <TextAmount value={value} />
  }

  return (
    <input
      id={_id}
      type="text"
      value={amount}
      onChange={(e) => handleChange(e.target.value)}
      onFocus={handleFocus}
      onBlur={handleBlur}
      placeholder={placeholder}
    />
    // <NumberFormat
    //   id={_id}
    //   value={value}
    //   onValueChange={(values, e) => handleChange(values, e)}
    //   onFocus={handleFocus}
    //   onBlur={handleBlur}
    //   decimalSeparator=","
    //   thousandSeparator="."        
    //   allowNegative={allowNegative}
    //   placeholder={placeholder}
    //   displayType={disabled}
    //   decimalScale={decimalScale}
    // />
  );
};

InputAmount.defaultProps = {
  allowNegative: false,
  disabled: false,
  useIconError: false,
  decimalScale: 0
};

InputAmount.propTypes = {
  name: PropTypes.string,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  onChange: PropTypes.func.isRequired,
  onFocus: PropTypes.func,
  onBlur: PropTypes.func,
  placeholder: PropTypes.string,
  maxLength: PropTypes.string,
  disabled: PropTypes.bool,
  allowNegative: PropTypes.bool,
  decimalScale: PropTypes.number
};

export default InputAmount;
